import { useRef } from "react";
import { useState } from "react";

import "./css/style.css";
import { NavLink } from "react-router-dom";
import SliderP1 from "../../modules/slider";

const URL_IMFG = "https://73kvartir.ru/img/product/";
export default function CatalogItem({
    gallary,
    title,
    rooms,
    square,
    description,
    price,
    id,
    img,
    url,
    hours_1,
    hours_2,
}) {

    
      
    return (
        <div className="catalogItem">
            <div className="slider">
                {gallary != null ? (
                    <SliderP1 imgArr={gallary} count={3}/>
                ) : (
                    <div className="slider_prev">
                        <img
                            src={URL_IMFG + img}
                            alt=""
                        />
                    </div>
                )}
            </div>
            <div className="info">
                <div className="info_text">
                    <span className="type">Квартира</span>
                    <span className="priceMob"><b>{price} ₽/сут.</b></span>

                    <NavLink to={`/kvartiry/${url}`}>
                        <h3>{title}</h3>
                    </NavLink>
                    <span className="size">
                        Количество комнат: {rooms}
                    </span>
                    <span className="size">
                        Общая площадь: {square}
                    </span>
                    <span className="info">
                        {description}
                    </span>
                </div>
                <NavLink
                    className="button"
                    to={`/kvartiry/${url}`}
                >
                    Подробнее
                </NavLink>
            </div>
            <div className="priseForm">
                <p className="price">
                    <b>{price} ₽/сут.</b>
                </p>
                <div className="discount">
                    <div className="discount-text">
                        <div className="warning">
                            Скидка
                        </div>
                        <div className="sub-discount">
                            на проживание от 3 сут.
                        </div>
                    </div>
                    <div className="discount-offer">
                        <div>2ч. - {hours_1!== null & hours_1 !=='' ? hours_1 : "1000"} ₽</div>
                        <div>3ч. - {hours_2!== null & hours_2 !=='' ? hours_2 : "1200"} ₽</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
